var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"vendeur-category-label"},[_vm._v(" "+_vm._s(_vm.vendeur.categoryLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }